import { ContactResponseDto } from '@qc/shared';

export interface ContactWithRole extends ContactResponseDto {
    roleDescription?: string;
    context?: string;
}

export interface ContactFormData {
    id?: string;
    entityContactId?: string;
    fullName: string;
    positionTitle?: string;
    email?: string;
    phone?: string;
    context?: string;
    roleDescription?: string;
}

export enum ContactDialogMode {
    SEARCH = 'search',
    CREATE = 'create',
    EDIT = 'edit',
}

export interface ContactFormConfig {
    showRoleFields: boolean;
    showContextField: boolean;
    requiredFields: string[];
    maxLengths: { [key: string]: number };
}

export interface ContactSelectorConfig {
    showCreateButton: boolean;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    required?: boolean;
}

export interface ContactOperationResult {
    success: boolean;
    contact?: ContactWithRole;
    error?: string;
}
